import {Button, withStyles} from '@material-ui/core';

const DangerButton = withStyles(() => ({
  root: {
    fontSize: 20,
    color: '#fff',
    background: '#F20024',
    borderRadius: 15,
    fontWeight: 'bolder',
    textDecoration: 'none',
    cursor: 'pointer',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: 1.5,
    '&:hover': {
      background: '#F20024',
      boxShadow: 'none',
      outline: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      outline: 'none',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
    },
  },
}))(Button);

export {DangerButton};
